import React from 'react';
import { Subscribe } from 'unstated';
import HelpMessageContentForm from './components/HelpMessageContentForm';
import { RouteComponentProps } from 'react-router-dom';
import HelpMessageContainer from '../../state/containers/HelpMessageContainer';
import ApplicationContainer from '../../state/containers/ApplicationContainer';
import TitleStateContainer from '../../state/containers/TitleStateContainer';
import FollowUpContainer from '../../state/containers/FollowUpContainer';
import RepromptContainer from '../../state/containers/RepromptContainer';
import MediaResponseStateContainer from '../../state/containers/MediaResponseContainer';
import ConversationNavigationState from '../../models/state/ConversationNavigationState';
import NavigationBarFormPage from '../formScenes/NavigationBarFormPage';
import HelpMessageModel from '../../models/features/api/Help/HelpMessageModel';
import GenericCreateContentItemPage from '../formScenes/GenericCreateContentItemPage';
import IResult from '../../models/result/IResult';
import FeatureContainer from '../../state/containers/FeatureContainer';
import { HelpMessagesFeatureTypeId } from '../../constants/featureTypeIds';

interface ApplicationRouteProps {
    applicationFeatureId: string
}
interface CreateHelpMessageProps extends RouteComponentProps<ApplicationRouteProps> { }

class CreateHelpMessage extends NavigationBarFormPage<CreateHelpMessageProps, ConversationNavigationState> {
    render() {
        return (
            <Subscribe to={[HelpMessageContainer, ApplicationContainer, TitleStateContainer, RepromptContainer, FollowUpContainer, MediaResponseStateContainer, FeatureContainer]}>
                {(helpContainer: HelpMessageContainer,
                    appContainer: ApplicationContainer,
                    titleContainer: TitleStateContainer,
                    repromptContainer: RepromptContainer,
                    followUpContainer: FollowUpContainer,
                    responseContainer: MediaResponseStateContainer,
                    featureContainer: FeatureContainer) => {
                    return (
                        <GenericCreateContentItemPage 
                            stateContainer={helpContainer}
                            titleContainer={titleContainer}
                            applicationContainer={appContainer}
                            defaultTitle="New Help Message"
                            history={this.props.history}
                            location={this.props.location}
                            match={this.props.match}
                            staticContext={this.props.staticContext}
                            featureContainer={featureContainer}
                            featureTypeId={HelpMessagesFeatureTypeId}
                            formRender={(application, assistantApplication, onPublish, onSubmit: (model: HelpMessageModel) => Promise<IResult<HelpMessageModel>>,onAccessTypeChange) => (

                                <HelpMessageContentForm
                                    location={this.props.location}
                                    application={application}
                                    applicationFeatureId={this.props.match.params.applicationFeatureId}
                                    stateContainer={helpContainer}
                                    assistantApplication={assistantApplication}
                                    appContainer={appContainer}
                                    followUpContainer={followUpContainer}
                                    repromptContainer={repromptContainer}
                                    featureContainer={featureContainer}
                                    responseStateContainer={responseContainer}
                                    onAccessTypeChange={onAccessTypeChange}
                                    onShowPublishModal={onPublish}
                                    history={this.props.history}
                                    isSaving={helpContainer.state.isSaving}
                                    onSubmit={onSubmit} />
                            )} />
                    );
                }}
            </Subscribe>
        );
    }
}

export default CreateHelpMessage;